/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var DeveloperSecretStatus;
(function (DeveloperSecretStatus) {
    DeveloperSecretStatus[DeveloperSecretStatus["SecretStatusActive"] = 1] = "SecretStatusActive";
    DeveloperSecretStatus[DeveloperSecretStatus["SecretStatusRevoked"] = 2] = "SecretStatusRevoked";
})(DeveloperSecretStatus || (DeveloperSecretStatus = {}));
